import axios from './axios'
import i18n from "./i18n";

const utils = {
    getAuthToken() {
        return 'Bearer ' + sessionStorage.getItem("auth-token");
    },
    getUrl(path) {
        if (process.env.VUE_APP_SERVICE_ID) {
            return process.env.VUE_APP_HOST + "/" + process.env.VUE_APP_SERVICE_ID + path;
        }
        return process.env.VUE_APP_HOST + path;
    },
    submit(formRef, url, data, done, error) {
        formRef.validate((valid) => {
            if (!valid) {
                return false;
            }

            let config = {};
            if (typeof data === "string") {
                config['headers'] = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(url, data, config).then(response => {
                if (response['code'] === 0) {
                    if (done) {
                        done(response.data);
                    }
                } else {
                    if (error) {
                        error(response);
                    }
                }
            });
        });
    },
    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    getEnumOptions(key) {
        let options = [];
        let obj = i18n.messages[i18n.locale]['enums'];
        key.split(".").forEach(v => {
            obj = obj[v] || {};
        });

        Object.keys(obj).forEach(k => {
            options.push({value: k, label: obj[k]});
        });

        return options;
    },
    getEnumLabel(category, value) {
        let options = utils.getEnumOptions(category);
        let label = value;
        options.forEach(option => {
            if (option['value'] === value) {
                label = option['label'];
                return false;
            }
        });
        return label;
    }
};

export default utils;